<template>
    <transition name="fade-fast">
        <div v-if="isOpen"
             ref="showPlan"
             class="popup popup_theme_slide-top-mobile">
            <div class="popup__container">
                <div class="popup__content">
                    <div class="plan__popup">
                        <div class="plan__popup-header">
                            <div v-if="name"
                                 class="plan__popup-name"
                                 v-html="name" />
                            <div v-if="area"
                                 class="plan__popup-area">
                                {{ area }} м²
                            </div>
                            <div class="plan__popup-pdf">
                                <div v-if="loading"
                                     class="plan__popup-pdf-load">
                                    <div class="plan__popup-pdf-icon">
                                        <IconLoad id="-plan-pdf-load"
                                                  class="icon_color_blue" />
                                    </div>
                                    <span>Формируем PDF...</span>
                                </div>
                                <STBaseButton v-else
                                              text="Скачать PDF"
                                              icon-after="IconRightFill"
                                              icon-after-modify="icon-fill icon_color_blue"
                                              modify="button_theme_reset"
                                              @click="generatePdfLink" />
                            </div>
                        </div>
                        <div class="plan__popup-content">
                            <img :src="srcImage"
                                 :alt="altText">
                        </div>
                        <div class="plan__popup-buttons" />
                    </div>
                </div>
                <button class="popup__close"
                        @click="close()">
                    <IconCloseBig class-name="icon-stroke icon_color_label icon_close_big" />
                </button>
            </div>
            <div class="popup__overlay"
                 @click="close()" />
        </div>
    </transition>
</template>

<script>
import IconCloseBig from '@/components/Icons/CloseBig';
import IconLoad from '@/components/Icons/Load';
import {mapActions} from 'vuex';

export default {
    components: {
        IconCloseBig,
        IconLoad
    },

    props: {
        name    : String,
        area    : [String, Number],
        srcImage: String,
        altText : String
    },

    data() {
        return {
            isOpen : false,
            loading: false
        };
    },

    methods: {
        ...mapActions(['getPdfPage']),

        openPlan() {
            this.isOpen = true;
        },

        close() {
            this.isOpen = false;
        },

        async generatePdfLink() {
            this.loading = true;

            const data = {
                name : this.name,
                area : this.area,
                image: this.srcImage
            };
            let url = '';

            await this.getPdfPage({
                type: 'plans',
                data
            })
                .then((response) => {
                    if (response.request.status) {
                        url = response.request.pdfPath;
                    }
                })
                .catch((error) => {
                    console.error(error);
                });

            this.loading = false;

            this.downloadUrl(url);
        },

        downloadUrl(url) {
            const link = document.createElement('a');
            link.setAttribute('download', '');
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
    }
};
</script>
